module.exports = __webpack_public_path__ + "img/welcome.7f38bf1c.jpg";